<template>
	<div class="col">
		<div class="card mb-3">
			<div class="card-header d-flex justify-content-between align-items-center">
				{{ log.log_date }} at {{ log.log_time_formatted }} - {{ log.reason.name ?? 'No Reason' }}
				<div>
	                <button class="btn btn-sm btn-outline-secondary" @click="openForm">Edit</button>
	                <button class="btn btn-sm btn-outline-danger ms-2" @click="deleteLog">Delete</button>
	            </div>
			</div>
	        <div class="card-body">
	            <div class="card-text">
	            	<dl class="row">
	            		<dt class="col-sm-3">Recipient:</dt>
            			<dd class="col-sm-9">{{ log.recipient.full_name }} ({{ recipientType }})</dd>

            			<dt class="col-sm-3">{{ log.channel.name }}:</dt>
            			<dd class="col-sm-9">{{ log.channel.formattedAddress }}</dd>

			            <dt class="col-sm-3">Status:</dt>
			            <dd class="col-sm-9">{{ log.status.name ?? 'NO STATUS' }}</dd>

			            <dt class="col-sm-3">Notes:</dt>
			            <dd class="col-sm-9">{{ log.notes }}</dd>
	            	</dl>
	            </div>
	        </div>
	    </div>
	</div>
</template>

<script>
export default {
	props: {
		log: Object,
		participant: Object
	},
	methods: {
		deleteLog() {
			this.$store.dispatch('communications/deleteLog', this.log)
		},
		openForm() {
            this.$store.dispatch('communications/setFormOpen', true)
            this.$store.dispatch('communications/setLogInForm', this.log)
        },
	},
	computed: {
		recipientType() {
			let type = this.log.recipient_type
			return type.split('App\\Models\\').pop()
		}
	}
}

</script>